

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

import React, { useState, useEffect } from "react";
import { View, Text, Modal, TouchableOpacity } from "react-native-web";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import styles from "./styles";
import compareWordWithWordOfTheDay from "./comparedWords";
import { initializeAnalytics, trackPageView } from "./googleAnalyticsTracking";
import ScoreChart from "./ScoreChart";
import LineChart from "./lineChart";
import ToggleButton from "./toggleButton";

const AnalyticsPage = () => {
    const [cookieData, setCookieData] = useState(null);
    const [todayData, setTodayData] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const [totalScore, setTotalScore] = useState(0); // State to store total score
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

    const [modalVisible, setModalVisible] = useState(false);

    const [showDaily, setShowDaily] = useState(true); // Toggle state for daily/total score

    useEffect(() => {
        initializeAnalytics();
        trackPageView(window.location.pathname); // Track initial page load
    }, []);

    useEffect(() => {
        const storedData = localStorage.getItem('gameData');
        console.log('storedData', storedData)
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            setCookieData(parsedData);
        } else {
            console.log('No Data found');
        }
    }, []);

    useEffect(() => {
        if (cookieData) {
            const today = new Date().toISOString().split('T')[0];
            setSelectedDate(today);
            filterDataByDate(today); // Filter data for today's date
            calculateTotalScore(cookieData); // Calculate total score for all data
        }
    }, [cookieData]); // Depend on cookieData state

    const filterDataByDate = (date) => {
        if (!cookieData) return; // Ensure cookieData is available
        const todayGames = [];

        Object.keys(cookieData).forEach((key) => {
            cookieData[key].forEach((game) => {
                const gameDate = new Date(game.date).toISOString().split('T')[0];
                if (gameDate === date) {
                    todayGames.push(game);
                }
            });
        });

        setTodayData(todayGames);
    };

    const calculateTotalScore = (data) => {
        const allGames = [];
        let total = 0; // Initialize total score
        if (data) {
            Object.keys(data).forEach((key) => {
                data[key].forEach((game) => {
                    allGames.push(game);
                    total += game.score; // Accumulate score
                });
            });
        }
        setTotalData(allGames);
        setTotalScore(total); // Update total score state
    };

    const handleDateSelect = (date) => {
        const selected = date.toISOString().split('T')[0];
        setSelectedDate(selected);
        filterDataByDate(selected);
    };

    const toggleModal = () => {
        setModalVisible(!modalVisible);
    };





    const renderColoredLetters = (word, comparisonResult) => {
        return word.split("").map((letter, index) => {
            const comparison = comparisonResult[index];
            const color = comparison ? comparison.color : "black";
            return (
                <Text key={index} style={{ color }}>
                    {letter}
                </Text>
            );
        });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: "numeric" }).format(date);
    };

    return (
        <View style={styles.landingPage}>
            <Modal
                animationType="fade"
                transparent={true}
                visible={modalVisible}
                onRequestClose={toggleModal}
            >
                <TouchableOpacity
                    style={styles.modalOverlay}
                    onPress={(e) => e.stopPropagation()} // Prevent closing when clicking the overlay
                >
                    <View
                        style={styles.modalContent}
                        onStartShouldSetResponder={(e) => e.stopPropagation()} // Prevent propagation when clicking inside modal content
                    >
                        <TouchableOpacity onPress={toggleModal} style={styles.closeButton}>
                            <Text style={styles.closeButtonText}>X</Text>
                        </TouchableOpacity>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateCalendar
                                value={new Date(selectedDate)}
                                onChange={handleDateSelect}
                            />
                        </LocalizationProvider>
                    </View>
                </TouchableOpacity>
            </Modal>









            <View style={styles.headerContainer}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text style={styles.sectionHeader}>
                        {showDaily ? "Daily Score" : "Total Score"}
                    </Text>
                    <ToggleButton showDaily={showDaily} setShowDaily={setShowDaily} />
                </View>


            </View>
            {showDaily ? (
                <>
                    <View style={{ flexDirection: 'row' }}>
                        <TouchableOpacity onPress={toggleModal} style={[styles.calendarButton, { marginRight: 10 }]}>
                            <FontAwesomeIcon icon={faCalendarAlt} color="black" />
                        </TouchableOpacity>
                        <Text style={styles.selectedDateText}>{formatDate(selectedDate)}</Text>
                    </View>
                    <View style={{ width: "85%", marginBottom: "2.5%" }}>
                        {todayData.length > 0 ? (
                            <>

                                <View style={styles.gameItem}>

                                    <View
                                        style={{
                                            justifyContent: "center",
                                            marginTop: "1%",
                                            alignItems: "center",
                                            flexDirection: 'row'


                                        }}
                                    >
                                        <Text style={{ fontWeight: "bold", fontSize: 30 }}>Total Score:</Text>
                                        <Text>
                                            {String((todayData.reduce((total, game) => total + game.score, 0))).split("").map((letter, index) => (
                                                <View
                                                    key={index}
                                                    style={{
                                                        height: "30px",
                                                        width: "30px",
                                                        backgroundColor: letter == "/" ? "#000000" : "#27ae60",  // Green box color
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        margin: 2, // Add space between the boxes
                                                        borderRadius: 5, // Optional: rounded corners,

                                                    }}
                                                >
                                                    <Text style={{ fontSize: 24, color: "white", fontWeight: "bold" }}>
                                                        {letter.toUpperCase()}
                                                    </Text>
                                                </View>
                                            ))}
                                        </Text>
                                    </View>

                                </View>



                            </>
                        ) : (
                            ""
                        )}
                    </View>
                    <View style={styles.todayDataContainer}>

                        {todayData.length > 0 ? (

                            todayData.map((game, index) => (
                                <View key={index} style={styles.gameItem}>
                                    <View style={{ width: "100%", height: "30px", backgroundColor: "#e0e0e0", position: "relative" }}>
                                        <View
                                            style={{
                                                height: "100%",
                                                width: `${game.score}%`, // Dynamically set the width based on score
                                                backgroundColor: game.score <= 33 ? "#eb4d4b" : game.score <= 66 ? "#f0932b" : "#27ae60", // Color of the progress bar
                                            }}
                                        />
                                    </View>
                                    <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: '1%' }}>
                                        <Text style={{ fontSize: 40, fontWeight: "bold" }}>{game.score}</Text>
                                        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                                            {game.word.split("").map((letter, index) => (
                                                <View
                                                    key={index}
                                                    style={{
                                                        height: "40px",
                                                        width: "40px",
                                                        backgroundColor: "#27ae60", // Green box color
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        margin: 2,
                                                        borderRadius: 5,
                                                    }}
                                                >
                                                    <Text style={{ fontSize: 24, color: "white", fontWeight: "bold" }}>
                                                        {letter.toUpperCase()}
                                                    </Text>
                                                </View>
                                            ))}
                                        </View>

                                    </View>
                                    <View style={styles.analyticsGuesses}>
                                        {game.wordGuesses.map((guess, guessIndex) => (
                                            <View key={guessIndex} style={styles.analyticsPill}>
                                                <Text style={styles.analyticsPillText}>
                                                    {renderColoredLetters(guess, compareWordWithWordOfTheDay(guess, game.word))}
                                                </Text>
                                            </View>
                                        ))}
                                    </View>

                                </View>
                            ))
                        ) : (
                            <Text>No data available for {formatDate(selectedDate)}</Text>
                        )}
                    </View>
                </>
            ) : (
                <View style={{ width: "100%" }}>
                    {cookieData ? (

                        <View>
                         
                            {/* <View style={{ width: "100%", height: "5%" }}></View> */}
                            <LineChart data={cookieData} />
                            <View style={{ width: "100%", height: "10%" }}></View>

                        </View>
                    ) : (
                        <Text>Loading chart data...</Text>
                    )}
                </View>)}

        </View>
    );
};

export default AnalyticsPage;
